import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../../../styles/icons/base.module.scss';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    className: null,
};

function IgaLogo({ color, className }) {
    return (
        <svg
            className={classNames([styles.container, { [className]: className !== null }])}
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width={50.03}
            height={23.37}
            viewBox="0 0 50.03 23.37"
        >
            <g transform="translate(0 0)">
                <path fill={color} d="M8.59,0L0,23.36h6.79L15.38,0H8.59z" />
                <g transform="translate(0 0)">
                    <g>
                        <defs>
                            <rect id="SVGID_1_" width="50.03" height="23.37" />
                        </defs>
                        <clipPath id="SVGID_00000008122026150893639280000004367120477959163028_">
                            <use xlinkHref="#SVGID_1_" overflow="visible" />
                        </clipPath>
                        <g clipPath="url(#SVGID_00000008122026150893639280000004367120477959163028_)">
                            <path
                                fill={color}
                                d="M23.01,10.34l-1.75,4.83h2c0.34-0.02,0.53,0.1,0.4,0.43c-0.01,0.03-0.65,1.73-0.65,1.73
					c-0.17,0.37-0.38,0.49-0.58,0.47c0,0-2.97,0.02-2.97,0c-1.05-0.1-0.9-1.11-0.76-1.58l3.09-8.56c0.39-0.95,0.68-1.58,2.42-1.58
					h6.68l2.16-6.1H20.61c-1.51,0.06-2.88,0.89-3.63,2.21l-5.66,15.6c-0.59,1.65-0.77,5.55,2.79,5.55h10.84l4.72-13.03L23.01,10.34z
					"
                            />
                            <path
                                fill={color}
                                d="M43.07,6.9l-1.22,3.3h-3.2L40,6.54c0.24-0.73,0.96-1.2,1.73-1.11
					C42.96,5.42,43.41,5.98,43.07,6.9 M44.22,0h-3.41c-3.72,0-5.21,1.28-5.79,2.84l-7.32,20.52h6.18l2.71-7.25h3.27l-2.29,7.25h6.43
					l5.68-17.31C51.12,1.77,48,0,44.22,0"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}

IgaLogo.propTypes = propTypes;
IgaLogo.defaultProps = defaultProps;

export default IgaLogo;
